import React from "react";
import { C } from "../../constants/design";
import { VITALITY_PER_LEVEL } from "../../engine/itemEngine";

// 1 vitality (vitesse) = 10 HP in Stadium Trial (PVE_HP_PER_VITESSE).
const HP_PER_VITALITY = 10;

const TICKET_ICON = "https://i.postimg.cc/d3sX5KSp/ticket-foot-viol-(1).png";

interface Props {
  level: number;
  gotTicket: boolean;
  /** Vitality (HP stat) gained on this level-up. Defaults to one level's worth. */
  vitalityGain?: number;
  onClose: () => void;
}

export function LevelUpScreen({ level, gotTicket, vitalityGain = VITALITY_PER_LEVEL, onClose }: Props) {
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 200,
        background: "rgba(0,0,0,0.85)",
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        gap: 24, padding: 32,
        backdropFilter: "blur(6px)",
      }}
    >
      <div style={{ fontSize: 64 }}>⬆️</div>

      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: C.muted, letterSpacing: 2, textTransform: "uppercase", marginBottom: 6 }}>
          Level Up!
        </div>
        <div style={{ fontSize: 52, fontWeight: 900, color: C.turf, lineHeight: 1 }}>
          Lvl {level}
        </div>
      </div>

      {/* Stat gain — vitality (HP) granted by the new level */}
      <div style={{
        display: "flex", alignItems: "center", gap: 12,
        background: "rgba(255,59,71,0.12)",
        border: "1px solid rgba(255,59,71,0.4)",
        borderRadius: 16, padding: "12px 22px",
      }}>
        <span style={{ fontSize: 30, lineHeight: 1 }}>❤️</span>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <span style={{ fontSize: 20, fontWeight: 900, color: "#FF6B6B", lineHeight: 1.1 }}>
            +{vitalityGain} Vitality
          </span>
          <span style={{ fontSize: 12, fontWeight: 600, color: C.muted }}>
            +{vitalityGain * HP_PER_VITALITY} Max HP
          </span>
        </div>
      </div>

      {gotTicket ? (
        <div style={{
          display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
          background: "rgba(168,85,247,0.12)",
          border: "1px solid rgba(168,85,247,0.4)",
          borderRadius: 20, padding: "20px 32px",
        }}>
          <img src={TICKET_ICON} alt="ticket" style={{ width: 48, height: 48, objectFit: "contain" }} />
          <div style={{ fontSize: 16, fontWeight: 900, color: "#C084FC" }}>
            +1 Loge Ticket !
          </div>
          <div style={{ fontSize: 12, color: C.muted }}>Drop rate 10% — nice luck!</div>
        </div>
      ) : (
        <div style={{ fontSize: 13, color: C.muted, textAlign: "center", maxWidth: 240 }}>
          Pas de ticket cette fois — continue à jouer pour en gagner à chaque level up (10% de chance).
        </div>
      )}

      <button
        onClick={onClose}
        style={{
          marginTop: 8,
          background: C.turf, color: "#050f0a",
          border: "none", borderRadius: 14,
          padding: "14px 40px", fontSize: 15, fontWeight: 900,
          cursor: "pointer",
        }}
      >
        Continuer
      </button>
    </div>
  );
}
